/*
  Accessibility fixes (accessScan audit, Sep 2026).

  Swiper's `loop` mode clones slides (`.swiper-slide-duplicate`) — the gallery
  carousel and announcement bar clones stay in the accessibility tree and their
  links stay keyboard-focusable, so screen reader and keyboard users hit the
  same content twice. The theme's own announcement clones
  (`.ui-overlap-item-clones`) hide the container with aria-hidden but leave the
  links inside focusable.

  This marks duplicate slides aria-hidden and removes their descendants (and
  those of already-hidden clone containers) from the tab order. Re-runs on DOM
  mutations because Swiper rebuilds duplicates on resize/section reload.
*/
(function () {
  'use strict';

  var FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])';

  function removeFromTabOrder(container) {
    container.querySelectorAll(FOCUSABLE).forEach(function (el) {
      el.setAttribute('tabindex', '-1');
    });
  }

  /*
    Patches for markup the theme doesn't render itself:
    - the recently-viewed / saved-cart app widget's carousel arrows
      (<button class="ar ar-l">) have no accessible name (Lighthouse button-name)
    - Shopify's video_tag filter emits a poster <img> without alt
      (Lighthouse image-alt); it's decorative, the video carries the meaning
    - Shopify's preview bar iframe has no title (preview URLs only)
  */
  /*
    The app widget (<accounts-everywhere>) renders inside an open shadow root,
    which document.querySelectorAll and the page-level MutationObserver can't
    see into. Collect every open shadow root and observe each one too.
  */
  var observedRoots = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
  var observeRoot = null;

  function collectRoots(root, roots) {
    roots.push(root);
    root.querySelectorAll('*').forEach(function (el) {
      if (el.shadowRoot) collectRoots(el.shadowRoot, roots);
    });
    return roots;
  }

  function patchThirdParty() {
    collectRoots(document, []).forEach(function (root) {
      if (root !== document && observeRoot && observedRoots && !observedRoots.has(root)) {
        observedRoots.add(root);
        observeRoot(root);
      }
      root.querySelectorAll('button.ar.ar-l:not([aria-label])').forEach(function (el) {
        el.setAttribute('aria-label', 'Previous');
      });
      root.querySelectorAll('button.ar.ar-r:not([aria-label])').forEach(function (el) {
        el.setAttribute('aria-label', 'Next');
      });
    });

    document.querySelectorAll('video img:not([alt])').forEach(function (el) {
      el.setAttribute('alt', '');
    });

    var previewBar = document.getElementById('PBarNextFrame');
    if (previewBar && !previewBar.hasAttribute('title')) {
      previewBar.setAttribute('title', 'Shopify preview bar');
    }
  }

  function neutralize() {
    document.querySelectorAll('.swiper-slide-duplicate').forEach(function (slide) {
      if (slide.getAttribute('aria-hidden') !== 'true') {
        slide.setAttribute('aria-hidden', 'true');
      }
      removeFromTabOrder(slide);
    });

    document.querySelectorAll('.ui-overlap-item-clones').forEach(removeFromTabOrder);

    patchThirdParty();
  }

  var scheduled = null;
  function schedule() {
    clearTimeout(scheduled);
    scheduled = setTimeout(neutralize, 100);
  }

  function init() {
    neutralize();

    if (typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(schedule);
      observeRoot = function (root) {
        observer.observe(root, { childList: true, subtree: true });
      };
      observeRoot(document.body);
      schedule();
    }

    window.addEventListener('load', schedule);
    document.addEventListener('shopify:section:load', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
